import React from 'react';
import MaterialTypography from '../../../components/MaterialTypography';
import MaterialBox from '../../../components/MaterialBox';

const baseStatusOptions = [
  { label: 'Waiting', value: 'waiting' },
  { label: 'In Progress', value: 'in_progress' },
  { label: 'Follow-Up', value: 'follow_up' },
  { label: 'Completed', value: 'completed' }
];

const StatusProgressBar = ({ status }) => {
  const isOverdue = status === "overdue";

  const visibleStatuses = isOverdue
    ? [...baseStatusOptions.filter(s => s.value !== "completed"), { label: "Overdue", value: "overdue" }]
    : baseStatusOptions;

  const totalStages = visibleStatuses.length;
  const progressIndex = visibleStatuses.findIndex(s => s.value === status);
  const progress = ((progressIndex + 1) / totalStages) * 100;
  const activeColor = isOverdue ? "#dc3545" : "#49c45f";

  return (
    <MaterialBox sx={{ width: '75%', mt: 4, ml: 12, position: 'relative' }}>
      {/* Progress Bar */}
      <MaterialBox
        sx={{
          height: 12,
          borderRadius: 5,
          background: `linear-gradient(to right, ${activeColor} ${progress}%, #e0e0e0 ${progress}%)`,
          transition: 'background 0.3s ease'
        }}
      />

      <MaterialBox
        sx={{
          position: 'absolute',
          top: 12,
          left: `${progress}%`,
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          borderTop: `10px solid ${activeColor}`,
          zIndex: 2
        }}
      />

      <MaterialBox sx={{ position: 'relative', height: 24, mt: 3 }}>
        {visibleStatuses.map((option, index) => {
          const labelLeft = ((index + 1) / totalStages) * 100;
          return (
            <MaterialTypography
              key={option.value}
              variant="caption"
              sx={{
                position: 'absolute',
                left: `${labelLeft}%`,
                transform: 'translateX(-50%)',
                fontWeight: option.value === status ? 'bold' : 'normal',
                color: option.value === "Overdue" ? "#d32f2f" : 'inherit',
                textAlign: 'center'
              }}
            >
              {option.label}
            </MaterialTypography>
          );
        })}
      </MaterialBox>
    </MaterialBox>
  );
};

export default StatusProgressBar;
